import { getBrowserEnv } from './browserEnv';

/**
 * Whether this browser can take a push subscription right now.
 *
 * Three call sites used to disagree about what "supported" meant — the
 * onboarding step checked only `Notification`, the home-screen prompt checked
 * `Notification` and `PushManager`, and `subscribeToPush` checked
 * `serviceWorker` and `PushManager`. On any browser where `Notification`
 * exists but the Push API does not, onboarding offered a button that could
 * only ever fail. This is the single source of truth for all of them.
 *
 * `needs-install` is the important state: iOS exposes the Push API only to
 * home-screen web apps, so in a Safari tab push is impossible but *fixable*.
 * That deserves "add Lincc to your home screen", not "not supported".
 */
export type PushSupport = 'supported' | 'needs-install' | 'unsupported';

export function getPushSupport(): PushSupport {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'unsupported';
  }

  if ('Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window) {
    return 'supported';
  }

  const env = getBrowserEnv();
  if (env.os === 'iOS' && !env.isStandalone) return 'needs-install';

  return 'unsupported';
}
